import { createAction, createReducer } from "@reduxjs/toolkit"
import { api } from "./helpers/api"

import { LOADING_INITIAL_STATE, setFailed, setReceived, setRequested } from "modules/loader-watchers/helpers/loading"

// ACTIONS
const requested = createAction("groups/requested")
const received = createAction("groups/received")
const failed = createAction("groups/failed")

// REDUCER
const initialState = {
  ...LOADING_INITIAL_STATE,
  items: []
}

const groupsReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(requested, (state) => {
      setRequested(state)
    })
    .addCase(received, (state, { payload }) => {
      setReceived(state)
      state.items = payload.data || []
    })
    .addCase(failed, (state) => {
      setFailed(state)
    })
})

// Public API
export const getGroups = () => (dispatch) => {
  return dispatch(
    api({
      url: "/guide/groups",
      onStart: requested.type,
      onSuccess: received.type,
      onError: failed.type
    })
  )
}

export default groupsReducer
